<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :title="'发送会员/分会'"
        :visible.sync="chioseDialog"
        center
        width="1500px">
        <div class="padding-tb">
            <div class="flex align-center margin-bottom-sm">
                <span>标签选择：</span>
                <el-select
                    v-model="label"
                    class="flex-sub"
                    clearable
                    filterable
                    multiple
                    placeholder="请选择标签"
                    @change="chioseMember">
                    <el-option
                        v-for="(item, index) in labels"
                        :key="index"
                        :label="item.name"
                        :value="index"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="flex justify-between margin-bottom-sm">
                <div class="flex align-start flex-sub">
                    <span class="label-title">会员选择：</span>
                    <div class="flex-sub">
                        <el-transfer
                            ref="memberTransfer"
                            v-model="value"
                            :data="memberList"
                            :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}',
            }"
                            :props="{
              key: 'user_id',
              label: 'company',
            }"
                            :titles="['全部会员', '已选择会员']"
                            class="flex width-100 align-center"
                            filterable
                        >
                            <span slot-scope="{ option }">{{ option.label }}</span>
                        </el-transfer>
                    </div>
                </div>
                <div class="flex align-start flex-sub margin-left">
                    <span class="label-title">分会选择：</span>
                    <div class="flex-sub">
                        <el-transfer
                            ref="fhTransfer"
                            v-model="valueFh"
                            :data="memberFhList"
                            :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}',
            }"
                            :props="{
              key: 'id',
              label: 'name',
            }"
                            :titles="['全部分会', '已选择分会']"
                            class="flex width-100 align-center"
                            filterable
                        >
                            <span slot-scope="{ option }">{{ option.label }}</span>
                        </el-transfer>
                    </div>
                </div>
            </div>
            <div class="flex align-center justify-around">
                <el-button class="font-size" style="width: 200px" @click="cancelChiose"
                >关闭
                </el-button
                >
                <el-button
                    class="font-size"
                    style="width: 200px"
                    type="primary"
                    @click="labelSave"
                >确定
                </el-button
                >
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {getUserListAllByEmail, getUserListAllFh, labelSelect} from '@/api/organiz'

export default {
    name: "chioseDialog",
    props: {
        chioseDialog: {
            type: Boolean,
            default: false
        },
        send_fenhui_id:{
            type: Array,
            default() {
                return [];
            }
        },
        send_user_id:{
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            type: 1,
            labels: [],
            label: [],
            value: [],
            valueObj: [],
            memberList: [],
            valueFh: [],
            valueObjFh: [],
            memberFhList: [],
            renderFunc(h, option) {
                return <span>{option.key} - {option.label}</span>;
            },
        }
    },
    created() {
        this.init()
    },
    methods: {
        //  关闭选择框
        cancelChiose() {
            this.clearSearch()
            this.$emit('cancelChiose')
        },
        //  选择标签保存
        labelSave() {
            if (this.value.length === 0 && this.valueFh.length === 0) return this.$message.error('请选择要发送的会员/分会')
            this.valueObj = []
            this.memberList.map(item => {
                this.value.map(id => {
                    if (item.user_id === id) {
                        this.valueObj.push(item)
                    }
                })
            })
            this.valueObjFh = []
            this.memberFhList.map(item => {
                this.valueFh.map(id => {
                    if (item.id === id) {
                        this.valueObjFh.push(item)
                    }
                })
            })
            this.clearSearch()
            this.$emit('saveChiose', [1, this.value, this.valueObj, this.valueFh, this.valueObjFh])
        },
        clearSearch() {
            this.$refs.memberTransfer.clearQuery('left')
            this.$refs.memberTransfer.clearQuery('right')
            this.$refs.fhTransfer.clearQuery('left')
            this.$refs.fhTransfer.clearQuery('right')
        },
        //  选择标签 会员数据同步
        chioseMember(val) {
            let _arr = []
            val.map(item => {
                if (this.labels[item].user_id_str) {
                    _arr = [..._arr, ...this.labels[item].user_id_str.split(',').map(Number)]
                    _arr = [...new Set(_arr)]
                }
            })
            this.value = _arr
        },

        //  获取全部标签和会员
        async init() {
            let _data = await labelSelect()
            this.labels = [..._data.data.rank, ..._data.data.fixedFourLable, ..._data.data.customLable]

            let _allMember = await getUserListAllByEmail()
            _allMember.data.map(item => {
                item.label = item.user_type === 1 ? item.company  : item.name
                item.key = item.user_id
            })
            this.value = this.send_user_id.map(item=>{
                    return item.user_id
                }
            )
            this.memberList = _allMember.data


            _allMember = await getUserListAllFh()
            _allMember.data.map(item => {
                item.label = item.name
                item.key = item.id
            })
            this.valueFh = this.send_fenhui_id.map(item=>{
                    return item.fenhui_id
                }
            )
            this.memberFhList = _allMember.data
        }

    },
    watch: {
        chioseType() {
            this.type = this.chioseType
        }
    }
}
</script>

<style lang="scss" scoped>
.chiose-title {
    width: 500px;
    margin: 0 auto;

    span {
        display: block;
        width: 180px;
        height: 40px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        border: 1px solid #ccc;
        border-radius: 5px;
        cursor: pointer;

        &.primary {
            background: #0d7fd7;
            color: #fff;
        }
    }
}

.search-some {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    span {
        display: block;
        width: 80px;
    }

    .el-input {
        flex: 1;
    }

    .el-select {
        flex: 1;
    }
}

.condition-list {
    height: 200px;
    overflow-y: auto;
    border: 1px solid #ccc;
    margin-bottom: 30px;
}
</style>